import {FC} from "react";
import './GridAreaContentLayoutLine.css'
import classnames from "classnames";

export const GridAreaContentLayoutLine: FC<{
  text: string | undefined,
  variant?: "Standard" | "Compact"
}> = ({
  text,
  variant = "Standard",
}) => {

  return (
    <>
      { text && (
        <div className={classnames("grid-area-content-layout-line", variant)}>
          {text}
        </div>
      )}
    </>
  )

}